<template>
  <component :is="$vuetify.breakpoint.mdAndUp ? 'v-menu' : 'v-dialog'"
             content-class="ruleinterval-selector-content"
             :width="'unset'"
             offset-y
             :min-width="'unset'"
             v-model="isMenuOpen"
             :close-on-click="($refs.ruleIntervalForm && isValid)"
             :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <div class="mock-select" :class="relevantClass" @click="on.click">
        <div class="d-flex flex-row align-center mock-containter">
          <div class="mock-icon">
            <v-icon size="20">icon-Pending</v-icon>
          </div>
          <div class="d-flex flex-column mock-content">
            <div class="mock-select-title" :class="relevantClass">{{label}}</div>
            <div class="mock-select-model" :class="relevantClass">{{chosenRuleText}}</div>
          </div>
        </div>
      </div>
    </template>
    <v-form ref="ruleIntervalForm">
      <div class="interval-type" :class="intervalParams.type === 'daily' ? 'd-flex flex-row align-top justify-space-between' : ''">
        <div :class="intervalParams.type === 'daily' ? 'type-selector-short' : ''">
          <VcitaSelectDropDown
            required
            :rules="requiredRule"
            :label="$t('settings.payments.automation.send_every')"
            v-model="intervalParams.type"
            :items="intervalTypes">
          </VcitaSelectDropDown>
        </div>
        <div v-if="intervalParams.type === 'daily'" class="interval-day-hour">
          <HourPicker
            :rules="hourRules"
            data-qa="rule-time-input"
            prepend-inner-icon="icon-Clock"
            :label="$t('settings.payments.automation.at')"
            name="time"
            :amPmMode="amPmMode"
            v-model="intervalParams.hour" >
          </HourPicker>
        </div>
      </div>
      <div v-if="intervalParams.type === 'monthly'" class="interval-rates d-flex flex-row align-top justify-space-between">
        <div class="interval-rate">
          <VcitaSelectDropDown
            required
            :rules="requiredRule"
            :label="$t('settings.payments.automation.on_the')"
            v-model="intervalParams.month_day"
            :items="intervalRates">
          </VcitaSelectDropDown>
        </div>
        <div class="interval-hour">
          <HourPicker
            :rules="hourRules"
            data-qa="rule-time-input"
            prepend-inner-icon="icon-Clock"
            :label="$t('settings.payments.automation.at')"
            name="time"
            :amPmMode="amPmMode"
            v-model="intervalParams.hour" >
          </HourPicker>
        </div>
      </div>
      <template v-if="intervalParams.type === 'weekly'">
        <div class="weekly-days-select">
          <v-layout class="day-buttons-title">
            {{$t('settings.payments.automation.on_the_following_days')}}
          </v-layout>
          <v-btn-toggle
            class="buttons-grp"
            v-model="intervalParams.week_days"
            multiple >
            <v-btn
              v-for="n in 7"
              v-bind:key="'day:'+n"
              elevation="0"
              :color="activeDaysMap[daysOfWeekNames[n-1]] ? brandBgColor : ''"
              class="day-btn"
              rounded
              icon
              height="24px"
              max-width="24px"
              min-width="24px"
              width="24px"
              :value="daysOfWeekNames[n-1]">
              {{i18nDaysOfWeekLetters[n-1]}}
            </v-btn>
          </v-btn-toggle>
          <div v-if="activeDaysMapEmpty" class="week-days-empty-error">
            {{$t('settings.payments.automation.one_day_required')}}
          </div>
        </div>
        <div class="interval-rates interval-hour hour-long">
          <HourPicker
            :rules="hourRules"
            data-qa="rule-time-input"
            prepend-inner-icon="icon-Clock"
            :label="$t('settings.payments.automation.at')"
            name="time"
            :amPmMode="amPmMode"
            v-model="intervalParams.hour" >
          </HourPicker>
        </div>
      </template>
      <v-layout class="ruleinterval-footer" justify-end>
        <v-btn
          @click="cancel"
          class="btn cancel-btn"
          :elevation="0"
          text
        >
          {{$t('common.dialog.cancel')}}
        </v-btn>
        <v-btn
          @click="save"
          class="btn done-btn"
          :elevation="0"
          :color="brandBgColor"
        >
          {{$t('common.dialog.done')}}
        </v-btn>
      </v-layout>
    </v-form>
  </component>

</template>

<script>
  import VcitaSelectDropDown from "@/modules/common/components/VcitaSelectDropDown/VcitaSelectDropDown.vue"
  import { HourPicker } from "@/modules/common/components"

  export default {
    name: 'RuleIntervalSelector',
    components: {
      VcitaSelectDropDown,
      HourPicker
    },
    props: {
      value:{
        type: Object,
        required: true
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      label: {
        type: String,
        required: true
      },
      amPmMode: {
        type: Boolean,
        required: true
      }
    },
    watch:{
      value: {
        handler(newVal, oldVal) {
          if(JSON.stringify(newVal) === JSON.stringify(oldVal)) {
            return
          }
          this.intervalParams = JSON.parse(JSON.stringify(newVal))
        },
        immediate: true,
      },
      isMenuOpen: {
        handler(val){
          if (!val && this.isValid){
            if (!this.isCancelled)
              this.$emit('input', JSON.parse(JSON.stringify(this.intervalParams)))
            else this.isCancelled = false;
          }
        }
      }
    }
    ,
    data() {
      let daysOfWeekNames = ['mo', 'tu', 'we', 'th', 'fr',  'sa', 'su']
      const daysOfWeekFullNames = {
        'mo': 'monday',
        'tu': 'tuesday',
        'we': 'wednesday',
        'th': 'thursday',
        'fr': 'friday',
        'sa': 'saturday',
        'su': 'sunday'
      }
      let i18nDaysOfWeekLetters = daysOfWeekNames.map(day => {
        return this.$t(`common.days_letters.${daysOfWeekFullNames[day]}`)
      })
      return {
        isCancelled: false,
        isMenuOpen: false,
        intervalParams: {
          type: 'monthly',
          month_day: '1',
          hour: '09:00',
          week_days: ['mo']
        },
        daysOfWeekNames,
        daysOfWeekFullNames,
        i18nDaysOfWeekLetters
      }
    },
    methods: {
      cancel() {
        this.isCancelled = true;
        this.isMenuOpen = false;
        this.intervalParams = JSON.parse(JSON.stringify(this.value))
      },
      save(){
        if (this.isValid){
          this.isMenuOpen = false;
          this.$emit('input', this.intervalParams);
        }
      },
      testAmPm(val) {
        const regexAmPm = /^([0]?[1-9]|1[0-2]):([0-5]\d)\s?(AM|PM)$/i;
        return regexAmPm.test(val)
      },
      test24(val) {
        const regex24 = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        return regex24.test(val)
      },
      dayToText(day){
        const dayNum = parseInt(day);
        if (day === 'last day') return this.$t(`settings.payments.automation.days_of_months.last_day`);
        return this.$t(`settings.payments.automation.days_of_months.${day}${[,'st','nd','rd'][dayNum/10%10^1&&dayNum%10]||'th'}`);
      },
    },
    computed: {
      brandBgColor() {
        return this.$store && this.$store.getters['brandModule/secondaryColor'];
      },
      activeDaysMap() {
        return this.intervalParams.week_days.reduce((acc, day) => {
          acc[day] = true
          return acc
        }, {})
      },
      activeDaysMapEmpty(){
        return Object.values(this.activeDaysMap).every(d => d === false);
      },
      relevantClass(){
        return this.disabled ? "disabled" : "";
      },
      isValid() {
        if (!this.$refs.ruleIntervalForm.validate())
          return false;
        if(this.intervalParams.type === 'weekly')
          return !this.activeDaysMapEmpty;
        return true;
      },
      intervalTypes(){
        return [
          {text: this.$t('settings.payments.automation.rule_interval_types.day'), value: 'daily'},
          {text: this.$t('settings.payments.automation.rule_interval_types.week'), value: 'weekly'},
          {text: this.$t('settings.payments.automation.rule_interval_types.month'), value: 'monthly'},
        ]
      },
      intervalRates(){
        let rates = [...Array(29).keys()].map(i => ({
          value: `${i + 1}`,
          text: this.$t(`settings.payments.automation.days_of_months.${i+1}${[,'st','nd','rd'][(i+1)/10%10^1&&(i+1)%10]||'th'}`)
        }));
        rates.push({
          value: 'last day',
          text: this.$t(`settings.payments.automation.days_of_months.last_day`)
        });
        return rates;
      },
      chosenRuleText(){
        const hour = this.intervalParams.hour;
        const week_days = (this.intervalParams.week_days || []).map(d => this.$t(`common.weekdays.${this.daysOfWeekFullNames[d]}`)).join(', ');
        const month_day = this.intervalParams.month_day && this.dayToText(this.intervalParams.month_day);
        return this.$t(`settings.payments.automation.interval_summaries.${this.intervalParams.type}`,{hour, week_days, month_day});
      },
      hourRules() {
        const that = this
        return [
          val => !!val || that.$t('common.errors.required_word'),
          val => that.testAmPm(val) || that.test24(val) || that.$t('common.errors.hour')
        ]
      },
      requiredRule(){
        return [val => !!val || this.$t('common.errors.required_word')]
      }
    }
  }

</script>

<style lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_i18n-mixins.scss";
  @import "@/assets/scss/abstract/_mixins.scss";
     .mock-select{
      background: #FFFFFF;
      border: 1px solid rgba(0, 0, 0, 0.12);
      box-sizing: border-box;
      border-radius: 6px;
      padding: 2px 10px 10px 10px;
      height: 52px;
      cursor: pointer;
      &.disabled{
        background: rgba(0, 0, 0, 0.03);
        border: 1px solid rgba(0, 0, 0, 0.2);
        cursor:unset;
      }
      .mock-containter{
        width: 100%;
        .mock-icon{
          width:29px;
          i {
            color:rgba(24, 11, 11, 0.4);
          }
        }
        .mock-content{
          width: 91%;
          .mock-select-title{
            height: 20px;
            font-weight: 400;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.62);
            &.disabled{
              color:rgba(0, 0, 0, 0.4);
            }
          }
          .mock-select-model{
            font-size: 15px;
            font-weight: 500;
            color:rgba(0, 0, 0, 0.87);
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: 100%;
            &.disabled{
              color:rgba(0, 0, 0, 0.4);
            }
          }
        }
        .mock-arrow{
          width: 10%;
        }
      }
    }
  .ruleinterval-selector-content {
    font-family: var(--primary-font-family);
      max-width: 327px;
      padding: 24px 16px 21px 16px;
      background-color: white;
    .interval-type{
      margin-bottom: 16px;
      .interval-day-hour{
        width:48%;
      }
      .type-selector-short{
        width:48%;
      }
    }
    .interval-rates{
      width: 100%;
      margin-bottom: 16px;
      .interval-rate{
        width:48%;
      }
      .interval-hour{
        width:48%;
        &.hour-long{
          width:100%;
          margin-bottom: 21px;
        }
      }
    }
    .day-buttons-title {
      font-family: var(--primary-font-family);
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;

      margin-bottom: 8px;
    }
    .week-days-empty-error{
      color:red;
      font-size: 12px;
      font-family: var(--primary-font-family);
      margin-top: 6px;
    }
    .weekly-days-select {
      margin-bottom: 16px;
      width: 100%;
      .buttons-grp{
        width:100%;
      }
    }
    .day-btn {
      background-color: #EAEDF2;
      margin-inline-end: auto;
      padding: 0 !important;
      border-radius: 1000px !important;
      border: none !important;
      font-size: 12px;
      &.v-btn--active {
        background-color: currentColor;
        span {
          color: #FFFFFF !important;
        }
      }
      &:first-child {
        margin-inline-start: 0;
      }
      &:last-child {
        margin-inline-end: 0;
      }
    }
    .btn {
      font-size: 13px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px;
      letter-spacing: 0px;
      height: 32px;
      text-transform: none;
    }
    .cancel-btn {
      margin: 0 4px;
    }
    .done-btn {
      color: #fff;
      &[disabled] {
        &.v-btn--disabled.v-btn--contained {
          background-color: rgba(0, 0, 0, 0.07) !important;
        }
      }
    }
  }

</style>
